import React, { useEffect, useState } from "react";
import {
    Autocomplete,
    Box,
    Button,
    CircularProgress,
    ListItem,
    TextField,
} from "@mui/material";
import { GenerateNewlyAddedUsersV2, getOnlyResourcingWorkers } from "../../../../../api/apiCall";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useAuth } from "../../../../../auth/auth";

const GeneratorReport = () => {
    const { state } = useAuth();
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState<any>([]);
    const [selectedUser, setSelectedUser] = useState<any>(null);

    const getUsers = async () => {
        const response = await getOnlyResourcingWorkers(state.user?.token);
        setUsers(response.data);
    }

    const { register, handleSubmit, watch } = useForm<any>({
        defaultValues: {
            startDate: "",
            endDate: "",
        },
    });

    const watchFields = watch();

    const onSubmit = async (data: any) => {
        setLoading(true);

        let formattedData: any

        formattedData = {
            startDate: data?.startDate,
            endDate: data?.endDate,
            userId: selectedUser?.id,
            name: selectedUser ? selectedUser.name + "_" + selectedUser.surname : null
        };

        const response = await GenerateNewlyAddedUsersV2(state.user?.token, formattedData);
        if (response?.status === 200) {
            toast.success("Report generated successfully!");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong!");
        }
    };

    const today = new Date().toISOString().split('T')[0];

    useEffect(() => {
        getUsers();
    }, []);

    return (
        <>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", md: "1fr" },
                    gap: 3
                }}>
                <Autocomplete
                    size="small"
                    options={users}
                    style={{marginTop: 10}}
                    onChange={(_, newValue) => {
                        setSelectedUser(newValue)
                    }}
                    getOptionLabel={(option: any) => {return option.name + " " + option.surname}}
                    renderOption={(props, option) => (
                        <ListItem {...props} key={option.name}>
                          {option.name}  {option.surname}
                        </ListItem>
                    )}
                    renderInput={(params) => (
                        <TextField {...params} label="Select Created By" placeholder="Select Created By" />
                    )}
                />
                <TextField
                    variant="outlined"
                    label="Start Date"
                    type="date"
                    size="small"
                    fullWidth
                    {...register("startDate")}
                    slotProps={{
                        htmlInput: {
                            max: watchFields.endDate || today
                        },

                        inputLabel: {
                            shrink: true,
                        }
                    }} />
                <TextField
                    variant="outlined"
                    label="End Date"
                    type="date"
                    size="small"
                    fullWidth
                    {...register("endDate")}
                    slotProps={{
                        htmlInput: {
                            min: watchFields.startDate,
                            max: today
                        },

                        inputLabel: {
                            shrink: true,
                        }
                    }} />

                <Button
                    fullWidth
                    variant="contained"
                    disabled={
                        loading
                    }
                    style={{
                        boxShadow: "none",
                        backgroundColor: "#1976d2",
                        color: "white",
                    }}
                    onClick={handleSubmit(onSubmit)}
                >
                    {loading ?
                        <CircularProgress size={25} style={{ color: "white" }} />
                        :
                        "Export Report"
                    }
                </Button>
                <div
                    style={{ textAlign: "center", margin: 4, marginBottom: -10 }}
                >
                    {loading && "This might take a while"}
                </div>
            </Box>
        </>
    );
};

export default GeneratorReport;
